export default {
  'exception-404.exception.back': 'Voltar para Início',
  'exception-404.description.404': 'Desculpe, a página que você visitou não existe',
};
